module.exports = __webpack_public_path__ + "img/color-picker.2662f717.gif";